/*
 * Day Picker View!!!!!!!!!!!
 * Wrapper for containing months and do all the logic
 *
 * Created by Vladimir Shishlyannikov on 24/09/2022.
 * Copyright (c) 2022 iWoo Ltd. All rights reserved.
 */

import React from 'react';
import { View } from 'react-native';
import PropTypes from 'prop-types'; // use directly
// import clsx from 'clsx';
import Lottie from 'react-lottie';

// import { withStyles, Theme } from '@material-ui/core/styles';
import { styled } from '@material-ui/core';

import * as dates from '../../../utils/dates';

import Header from '../Header/Header';
import Month from '../Month/Month';

// Hooks
// import useMonthViews from '../../../hooks/useMonthViews/useMonthViews';

import moment from 'moment-timezone';

import { date as dateLocalizer } from '../../../utils/localizers';

import { getMomentWithTz } from '../../../utils/date';
// import { _ } from '../../../utils/_';

import animationData from '../../../lotties/loading-spinner';

// }
// .ap-calendar-grid .ap-cell {
//     width: 40px;
//     height: 40px;
// }
// .ap-cell.ap-state-disabled {
//     color: #999;
//     filter: alpha(opacity=7);
//     opacity: .7;
// }
// .ap-cell, .ap-head-cell {
//     border: '0';
// }
// .ap-cell {
//     color: #333;
//     border-radius: 8px;
//     cursor: pointer;
//     line-height: normal;
//     border: 1px solid transparent;
// }

// const styles = ((theme: Theme) => ({
//   // drawer: {
//   //   display: 'flex',
//   //   width: theme.rightDrawerWidth,
//   //   height: `calc(100% - ${theme.footerHeight}px)`,
//   // },
//   // thumbnailContainer: {
//   //   display: 'flex',
//   //   'flex-wrap': 'wrap',
//   //   padding: '5px',
//   //   'overflow-y': 'auto',
//   // },
//   // apNavView: {
//   //   // table {
//   //   'border-collapse': 'collapse',
//   //   // }
//   // },
//   // apCalendarGrid: {
//   //   height: 'auto',
//   //   'border-collapse': 'collapse',
//   // },
//   // apCalendarRow: {
//   // // tr {
//   //   'border-bottom': '1pt solid rgb(203, 207, 213)',
//   // // }
//   // },
//   // apHeadCell: {
//   //   'font-family': "'Poppins', Arial, sans-serif",
//   //   'font-weight': 400,
//   //   'font-size': '12px',
//   //   'text-align': 'center',
//   //   'text-transform': 'uppercase',
//   //   color: theme.grey,
//   //   // .ap-cell, .ap-head-cell {
//   //   // text-align: center;
//   //   padding: '0',
//   //   border: '0',
//   //   'padding-bottom': '10px',
//   //   // }
//   // },
//   // apCell: {
//   //   width: '40px',
//   //   height: '40px',
//   //   color: '#333',
//   //   padding: '3px', // '9px 8px',
//   //   'border-radius': '8px',
//   //   cursor: 'pointer',
//   //   'line-height': 'normal',
//   //   border: '1px solid transparent',
//   //   'text-align': 'center',
//   // },
//   // apBtn: {
//   //   position: 'relative',
//   //   // margin: '0 auto',
//   //   // 'border-radius': '4px',
//   //   'border-radius': '50%',
//   //   // 'line-height': '24px',
//   //   width: '44px',
//   //   height: '44px',
//   //   // margin: '4px auto',
//   //   // padding: '10px 8px',
//   //   padding: '8px',
//   //   'font-size': '14px',
//   //   'font-weight': '400',
//   //   'line-height': '26px',
//   //   'letter-spacing': 'normal',
//   //   'font-family': '"Poppins",sans-serif',
//   //   border: '1px solid transparent',
//   //   "&:hover": {
//   //     'background-color': theme.greyLight,
//   //     border: '1px solid rgb(203, 207, 213)',
//   //   },
//   // },
//   // apBtn: {

//   // },
//   // apStateDisabled: {
//   //   color: '#999',
//   //   filter: 'alpha(opacity=7)',
//   //   opacity: '.7',
//   // },
//   // apStateSelected: {
//   //   background: theme.greyLight, // #F8F8F8
//   //   border: '1px solid rgb(203, 207, 213)',
//   // },
//   // apCellOffRange: {
//   //   color: '#999',
//   //   "& :hover": {
//   //     'background-color': 'transparent',
//   //     'border-color':  'transparent',
//   //   }
//   // },
//   // apBtn: {

// // .rw-btn, .rw-filter-input, .rw-input, .rw-input-reset {
// //     color: inherit;
// //     padding: '0';
// //     margin: 0;
// //     border: none;
// //     box-shadow: none;
// //     background: none;
// //     background-image: none;
// //     font-family: inherit;
// //     font-size: inherit;
// //     line-height: inherit;
// //     -ms-touch-action: manipulation;
// //     touch-action: manipulation;
// // }
//   // },
//   // apNow: {
//   //   color: theme.red,
//   // },

//   // overlay: {
//   //   position: 'absolute',
//   //   top: '0',
//   //   left: '0',
//   //   right: '0',
//   //   bottom: '82px',
//   //   'background-color': 'rgb(255, 255, 255)',
//   //   opacity: 0.7,
//   //   'z-index': 999,
//   // },

//   // loaderContainer: {
//   //   position: 'absolute',
//   //   top: '80px',
//   //   left: '50%',
//   //   transform: 'translateX(-50%)',
//   //   'z-index': 1000,
//   // },

// }));

export const LoaderContainer = styled('div')({
  position: 'absolute',
  top: '80px',
  left: '50%',
  transform: 'translateX(-50%)',
  'z-index': 1000,
});

// const VIEW_UNITS = ['month', 'year', 'decade', 'century'];
// var MONTH1    = 'month1',
//   MONTH2 = 'month2',
//   MONTH3 = 'month3';

const defaultOptions = {
  loop: true,
  autoplay: true,
  animationData: animationData,
  rendererSettings: {
    preserveAspectRatio: 'xMidYMid slice',
  },
};

// function clamp(date, min, max){
//   return dates.max(dates.min(date, max), min)
// }

class AvailabilityDayPickerView extends React.Component {
  static propTypes = {
    classes: PropTypes.object, //.isRequired,
    style: PropTypes.object,
    id: PropTypes.string,
    isFetching: PropTypes.bool.isRequired,
    region: PropTypes.string,
    label: PropTypes.string,
    todaysDate: PropTypes.instanceOf(Date),
    today: PropTypes.instanceOf(Date),
    disabled: PropTypes.bool,
    selected: PropTypes.instanceOf(Date),
    focused: PropTypes.instanceOf(Date),
    dayAvailability: PropTypes.object, // PropTypes.arrayOf(PropTypes.object),
    dayAvailabilityHash: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    bookedTimeSlots: PropTypes.object,
    date: PropTypes.instanceOf(Date),
    now: PropTypes.instanceOf(Date),
    min: PropTypes.instanceOf(Date),
    max: PropTypes.instanceOf(Date),
    // unit: PropTypes.oneOf(['day', ...VIEW_UNITS]),
    // viewUnit: PropTypes.oneOf(VIEW_UNITS),
    // currentDate: PropTypes.instanceOf(Date),
    onDaySelected: PropTypes.func.isRequired,
    // onChange: PropTypes.func, //.isRequired
  };

  static defaultProps = {
    isFetching: true,
    region: 'US',
  };

  // month params

  // month, year, mFirstDayOfWeek, enabledDayRangeStart, enabledDayRangeEnd, selectedDay[0], selectedDay[1]

  constructor(props) {
    super(props);

    // Set up min and max dates.
    let minDate = getMomentWithTz(new Date(), props.region).toDate(); // dates.today(); // new Date();
    let maxDate = getMomentWithTz(new Date(), props.region); // dates.today(); // new Date();

    maxDate.add(3, 'month');

    maxDate = maxDate.toDate();
    // final Calendar tempDate = Calendar.getInstance();
    // final long minDateMillis = tempDate.getTimeInMillis();
    // final long maxDateMillis = tempDate.getTimeInMillis();

    this.handleDaySelected = this.handleDaySelected.bind(this);
    this.renderMonthView = this.renderMonthView.bind(this);
    const format = dateLocalizer.getFormat('header', 'YYYY-MM' /*headerFormat*/);

    let monthViews = [0, 1, 2].reduce((acc, nextValue) => {
      let monthViewData = this.getMonthViewData(nextValue, minDate);
      let monthViewKey = getMomentWithTz(monthViewData.startDate, props.region).format(format /*, props.culture*/);

      acc[monthViewKey] = monthViewData;

      return acc;
    }, {});

    this.state = {
      monthViews,
      minDate,
      maxDate,
    };
  }

  // getCurrentDate(): Date {
  //    return this.props.currentDate || this.props.value || new Date();
  // }

  handleDaySelected(day: Date) {
    // mCurrentDate = day;
    // this.setState({ currentDate: day });

    // const year = dates.year(day); // currentDate.year();

    // if (callbackToClient && mDateChangedListener != null) {
    //     mDateChangedListener.onDateChanged(this, day);
    // }

    // mDayPickerView.setDate(day, false);

    this.setState({ selectedDay: day });

    // Passthrough to the parent
    this.props.onDaySelected(day);

    // onCurrentDateChanged(fromUser);
  }

  onDateChanged(view /* AvailabilityDatePicker  */, selectedDate: Date) {
    // Context context = getContext();
    // We get here after seleting a date
    // mDatePicker.init(selectedDate,this);
    // mTimePicker.setCurrentDay(selectedDate);
    // mTimePickerGridView.setVisibility(View.INVISIBLE);
    // mSlidingUpPanelLayout.setPanelState(TBSlidingUpPanelLayout.PanelState.ANCHORED);
  }

  getHeaderLabel(date = this.state.minDate): string {
    let { culture, headerFormat } = this.props;
    // currentDate = dates.add(minDate, monthIndex, 'month');// this.getCurrentDate();

    headerFormat = dateLocalizer.getFormat('header', 'MMMM' /*headerFormat*/);
    // headerFormat = headerFormat || 'MMMM YYYY';

    // if (['LEFT', 'RIGHT'].indexOf(direction) !== -1) {
    //     let method = direction === 'LEFT' ? 'subtract' : 'add';

    //     return dateLocalizer.format(dates[method](this.getCurrentDate(), 1, this.state.view), headerFormat, culture);
    // }

    return getMomentWithTz(date, this.props.region).format(headerFormat /*, culture*/);
  }

  getMonthViewData(monthIndex: number, minDate: Date) {
    let minDateTmp;

    if (monthIndex > 0) {
      minDateTmp = getMomentWithTz(minDate, this.props.region).add(monthIndex, 'month');
    } else {
      minDateTmp = getMomentWithTz(new Date(minDate), this.props.region);
    }

    return {
      startDate: minDateTmp
        .clone()
        .startOf('month')
        .toDate(),
      endDate: minDateTmp
        .clone()
        .endOf('month')
        .toDate(),
      year: minDateTmp.year(),
      month: minDateTmp.month(),
      hasBookingsDays: [],
      highlightedDays: [],
      hoursCount: 0,
      headerLabel: this.getHeaderLabel(minDateTmp.toDate()),
    };
  }

  componentDidUpdate(prevProps) {
    // if (!_.isShallowEqual(prevProps.dayAvailability, this.props.dayAvailability)) {
    if (prevProps.dayAvailabilityHash !== this.props.dayAvailabilityHash) {
      if (this.props.dayAvailability) {
        // const newMonthViews = useMonthViews(this.props.dayAvailability);

        // const monthViews = this.state.monthViews;

        // Object.keys(monthViews).map(monthViewKey => {
        //   monthViews[monthViewKey] = {
        //     ...monthViews[monthViewKey],
        //     hoursCount: newMonthViews[monthViewKey].hoursCount,
        //     highlightedDays: newMonthViews[monthViewKey].highlightedDays,
        //     hasBookingsDays: newMonthViews[monthViewKey].hasBookingsDays,
        //   }
        // });

        // this.setState({ monthViews });
        let monthViews = {};

        Object.keys(this.state.monthViews).forEach(monthViewKey => {
          monthViews[monthViewKey] = {
            ...this.state.monthViews[monthViewKey],
            highlightedDays: [],
            hoursCount: 0,
          };
        });

        this.props.dayAvailability.forEach(da => {
          // const dayFormat = dateLocalizer.getFormat('header', 'YYYY-MM-DD'/*headerFormat*/);
          // SimpleDateFormat sdf = new SimpleDateFormat("yyyy-MM-dd", Locale.ENGLISH);

          let [year, month, day] = getMomentWithTz(moment.utc(da.start), this.props.region)
            // .local()
            .format('YYYY-MM-DD')
            .split('-');
          // day = day.substring(0, 2);
          const monthViewKey = `${year}-${month}`;

          // let slotType: string = da.slotType;

          // TODO: fixate time zone to LA
          // Quick fix to an issue with time zones, when edge time slots causing
          // different months in the Calendar. If for example the user has UTC+1
          // offset then “2023-08-31T23:00:00.000Z” time would cause September to show up.
          // When the August should be the last. The behaviour of this is unpredictable.
          // Hope it'll work :)
          if (!monthViews[monthViewKey]) {
            return;
          }

          // if (month == monthView.month) {
          // let hasSetAvailableDays: boolean = false;
          // let hasBookings: boolean = false;

          // if (!monthViews[monthViewKey]) {
          //   monthViews[monthViewKey] = {
          //     highlightedDays: [],
          //     hasBookingsDays: [],
          //     hoursCount: 0,
          //   };
          // }

          // const monthView = this.state.monthViews[`${year}-${month}`];

          // try {
          //     tempDate.setTime(sdf.parse(da.getDay()));// all done
          // } catch (ParseException e) {
          //     e.printStackTrace();
          // }

          // int month = tempDate.get(Calendar.MONTH);
          // let slotType: string;

          // let hasSetAvailableDays: boolean = false;
          // let hasBookings: boolean = false;

          // da.timeSlots?.forEach(ts => {
          //   const slotType = ts.slotType;

          //     if (slotType === 'AVAILABLE' ||
          //       slotType === 'IN_SESSION' || // ???
          //       slotType === 'IS_NOT_AVAILABLE_FOR_BOOKING' // ???
          //     ) {
          //       hasSetAvailableDays = true;
          monthViews[monthViewKey].hoursCount += 0.5;
          //     }

          //     if (slotType === 'IN_SESSION') {
          //       hasBookings = true;
          //     }
          // });

          // if (hasSetAvailableDays) {
          monthViews[monthViewKey].highlightedDays[Number(day)] = 1;
          // }

          // if (hasBookings) {
          //   monthViews[monthViewKey].hasBookingsDays[Number(day)] = 1;
          // }
        });

        // Object.keys(this.state.monthViews).forEach(monthViewKey => {
        //   if (!monthViews[monthViewKey]) {
        //     // monthViews[monthViewKey] = {...this.state.monthViews[monthViewKey] };

        //     return;
        //   }
        //   monthViews[monthViewKey].startDate = this.state.monthViews[monthViewKey].startDate;
        //   monthViews[monthViewKey].endDate = this.state.monthViews[monthViewKey].endDate;
        //   monthViews[monthViewKey].year = this.state.monthViews[monthViewKey].year;
        //   monthViews[monthViewKey].month = this.state.monthViews[monthViewKey].month;
        //   monthViews[monthViewKey].headerLabel = this.state.monthViews[monthViewKey].headerLabel;
        //   monthViews[monthViewKey].hasBookingsDays = this.state.monthViews[monthViewKey].hasBookingsDays;
        // });

        this.setState({ monthViews });
      }
    }

    if (prevProps.bookedTimeSlots !== this.props.bookedTimeSlots && this.props.bookedTimeSlots) {
      let monthViews = this.state.monthViews;

      Object.keys(this.state.monthViews).forEach(monthViewKey => {
        monthViews[monthViewKey] = {
          ...this.state.monthViews[monthViewKey],
          hasBookingsDays: [],
        };
      });

      Object.keys(this.props.bookedTimeSlots).forEach(da => {
        let [year, month, day] = getMomentWithTz(moment.utc(da), this.props.region)
          // .local()
          .format('YYYY-MM-DD')
          .split('-');
        const monthViewKey = `${year}-${month}`;

        // let hasBookings: boolean = false;

        // if (!monthViews[monthViewKey]) {
        //   monthViews[monthViewKey] = {
        //     highlightedDays: [],
        //     hasBookingsDays: [],
        //     hoursCount: 0,
        //   };
        // }

        monthViews[monthViewKey].hasBookingsDays[Number(day)] = 1;
      });

      // Object.keys(this.state.monthViews).forEach(monthViewKey => {
      //   if (!monthViews[monthViewKey]) {
      //     return;
      //   }
      //   monthViews[monthViewKey].startDate = this.state.monthViews[monthViewKey].startDate;
      //   monthViews[monthViewKey].endDate = this.state.monthViews[monthViewKey].endDate;
      //   monthViews[monthViewKey].year = this.state.monthViews[monthViewKey].year;
      //   monthViews[monthViewKey].month = this.state.monthViews[monthViewKey].month;
      //   monthViews[monthViewKey].headerLabel = this.state.monthViews[monthViewKey].headerLabel;
      // });

      this.setState({ monthViews });
    }
  }

  renderMonthView(key, index) {
    const { /*value, */ todaysDate, disabled, region /*currentDate,*/ } = this.props;
    const { monthViews } = this.state;
    const monthView = monthViews[key];

    return (
      <React.Fragment key={index}>
        <Header
          // // isRtl={this.isRtl()}
          label={monthView.headerLabel}
          daysCountLabel={monthView.highlightedDays.filter(v => v).length}
          hoursCountLabel={Math.floor(monthView.hoursCount)}
          // prevLabel={this.getHeaderLabel('LEFT')}
          // nextLabel={this.getHeaderLabel('RIGHT')}
          // labelId={this.labelId}
          // messages={this.messages}
          // // upDisabled={isDisabled || view === last(views)}
          // prevDisabled={isDisabled || !dates.inRange(this.nextDate('LEFT'), min, max, view)}
          // nextDisabled={isDisabled || !dates.inRange(this.nextDate('RIGHT'), min, max, view)}
          // onViewChange={this.handleViewChange}
          // onMoveLeft ={this.handleMoveBack}
          // onMoveRight={this.handleMoveForward}
        />
        <Month
          // {...viewProps}
          // key={key}
          key={key}
          // id={this.viewId}
          // activeId={this.activeId}
          // value={value}
          region={region}
          today={todaysDate}
          minDate={monthView.startDate}
          maxDate={monthView.endDate}
          disabled={disabled}
          hasBookingsDays={monthView.hasBookingsDays}
          highlightedDays={monthView.highlightedDays}
          // prevDisabled={isDisabled || !dates.inRange(this.nextDate('LEFT'), min, max, 'week')}
          // nextDisabled={isDisabled || !dates.inRange(this.nextDate('RIGHT'), min, max, 'week')}
          focused={monthView.startDate /*currentDate*/}
          dayFormat={'dd'}
          onChange={this.handleDaySelected}
          // aria-labelledby={this.labelId}
          // onMoveLeft ={this.handleMoveBack}
          // onMoveRight={this.handleMoveForward}
        />
      </React.Fragment>
    );
  }

  render() {
    const { /*classes, */ isFetching } = this.props;
    // let { minDate, maxDate } = this.state;
    const { monthViews } = this.state;

    // console.log('AvailabilityDayPickerView render');

    return (
      <>
        {Object.keys(monthViews).map(this.renderMonthView)}
        {isFetching && (
          <>
            <LoaderContainer>
              <Lottie options={defaultOptions} height={128} width={128} />
            </LoaderContainer>
            <View
              // className={classes.overlay}
              style={{
                position: 'absolute',
                top: '0',
                left: '0',
                right: '0',
                bottom: '82px',
                backgroundColor: 'rgb(255, 255, 255)',
                opacity: 0.7,
                zIndex: 999,
              }}
            ></View>
          </>
        )}
      </>
    );
  }

  handleChange(date: Date) {
    return null;
  }
}

// class AvailabilityViewCell extends React.Component {
//   static propTypes = {
//     classes: PropTypes.object.isRequired,
//     style: PropTypes.object,
//     id: PropTypes.string,
//     label: PropTypes.string,
//     today: PropTypes.instanceOf(Date),
//     disabled: PropTypes.bool,
//     selected: PropTypes.instanceOf(Date),
//     focused: PropTypes.instanceOf(Date),
//     date: PropTypes.instanceOf(Date),
//     now: PropTypes.instanceOf(Date),
//     min: PropTypes.instanceOf(Date),
//     max: PropTypes.instanceOf(Date),
//     unit: PropTypes.oneOf(['day', ...VIEW_UNITS]),
//     viewUnit: PropTypes.oneOf(VIEW_UNITS),
//     onChange: PropTypes.func, //.isRequired
//   };

//   isEqual(date) {
//     return dates.eq(this.props.date, date, this.props.unit)
//   }

//   isEmpty() {
//     let { unit, min, max, date } = this.props;
//     return !dates.inRange(date, min, max, unit)
//   }

//   isNow() {
//     return this.isEqual(this.props.now)
//   }

//   isFocused() {
//     return this.isEqual(this.props.focused)
//   }

//   isSelected() {
//     return this.isEqual(this.props.selected)
//   }

//   isOffView() {
//     let { viewUnit, focused, date } = this.props;
//     return viewUnit && dates[viewUnit](date) !== dates[viewUnit](focused);
//   }

//   handleChange = () => {
//     let { onChange, min, max, date } = this.props;
//     onChange(clamp(date, min, max));
//   }

//   render()  {
//     let { children, id, label, disabled } = this.props;

//     // if (this.isEmpty()) {
//     //   return <td className='ap-empty-cell' role='presentation'>&nbsp;</td>
//     // }

//     return (
//       <td
//         role='gridcell'
//         id={id}
//         title={label}
//         aria-label={label}
//         aria-readonly={disabled}
//         aria-selected={this.isSelected()}
//         className={clsx(
//             'ap-grid-cell',
//             // this.props.className,
//             this.props.classes.apCell,
//             this.isOffView() && this.props.classes.apCellOffRange, //'ap-off-range',
//             this.isFocused() && this.props.classes.apStateFocused, //'ap-state-focus',
//             this.isSelected() && this.props.classes.apStateSelected, // && this.props.classes.apStateDisabled, //'ap-state-selected',
//             this.isEmpty() && 'ap-empty-cell'
//           )}
//         style={this.props.style}
//       >
//         <div
//           aria-labelledby={id}
//           onClick={this.handleChange}
//           className={clsx(
//             'ap-btn',
//             this.props.classes.apBtn,
//             this.isSelected() && this.props.classes.apStateSelected,
//             this.isNow() && this.props.classes.apNow //'ap-now'
//           )}
//         >
//           {children}
//         </div>
//       </td>
//     )
//   }
// }

// AvailabilityView.Row = props => <tr role='row' {...props} />;
// AvailabilityView.Cell = withStyles(styles)(AvailabilityViewCell);

// export default withStyles(styles)(AvailabilityDayPickerView); //CalendarView;
export default AvailabilityDayPickerView; //CalendarView;
